export default "__VITE_ASSET__BtQqkr99__"